import type { GetPublishedPostResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function usePublishedPost(
  id: number,
): UseQueryResult<GetPublishedPostResponse> {
  return useQuery<GetPublishedPostResponse>({
    queryFn: () =>
      apiClient.url(`/social-publishing/published-posts/${id}`).get().json(),
    queryKey: socialPublishingKeys.publishedPost(id),
  });
}
